
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductMoldsDialog extends _Ext.ItemEditorDialog<ProductMoldsRow> {
        protected getFormKey() { return ProductMoldsForm.formKey; }
        protected getIdProperty() { return ProductMoldsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductMoldsRow.localTextPrefix; }
        protected getService() { return ProductMoldsService.baseUrl; }
        protected getDeletePermission() { return ProductMoldsRow.deletePermission; }
        protected getInsertPermission() { return ProductMoldsRow.insertPermission; }
        protected getUpdatePermission() { return ProductMoldsRow.updatePermission; }

        protected form = new ProductMoldsForm(this.idPrefix);

    }
}